import React from 'react';
import _ from 'lodash';
import names from './names';
import realNames from './realNames';
import StartupNameGenerator from '../StartupNameGenerator';
import StartupNameGuesser from '../StartupNameGuesser';

class Startups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nextIdx: 2,
      generatorIdx: 0,
      guesserIdx: 1,
      correct: 0,
      total: 0,
    };
  }

  componentWillMount() {
    this.names = _.shuffle(names);
    this.realNames = _.shuffle(realNames);
    this.nNames = names.length;
    this.nRealNames = realNames.length;
  }

  generate() {
    this.setState({
      generatorIdx: this.state.nextIdx,
      nextIdx: this.state.nextIdx + 1,
    });
  }

  newGuess(guessedCorrectly) {
    this.setState({
      guesserIdx: this.state.nextIdx,
      nextIdx: this.state.nextIdx + 1,
      correct: this.state.correct + (guessedCorrectly ? 1 : 0),
      total: this.state.total + 1,
    });
  }

  render() {
    return (
      <div>
        <p>
          It's a Silicon Valley pasttime to poke fun at startup culture -
          from&nbsp;
          <a href="https://www.kamogo.com/5">
            awful startup idea generators
          </a>
          &nbsp; to <a href="http://welcometobusinesstown.tumblr.com/">
            Business Town
          </a>.
          I made a startup name generator based on an RNN that
          learns patterns from real startup names. Click the button to generate
          some:
        </p>
        <StartupNameGenerator
          name={this.names[this.state.generatorIdx % this.nNames]}
          generate={() => this.generate()}
        />
        <p>
          Another fun way to enjoy this generator is by guessing which startup
          name is real and which is computer-generated, much like
          &nbsp;
          <a href="http://snarxiv.org/vs-arxiv/">
            arXiv vs snarXiv
          </a>
          :
        </p>
        <StartupNameGuesser
          name={this.names[this.state.guesserIdx % this.nNames]}
          realName={this.realNames[this.state.guesserIdx % this.nRealNames]}
          correct={this.state.correct}
          total={this.state.total}
          newGuess={(correct) => this.newGuess(correct)}
        />
      </div>
    );
  }
}

export default Startups;



// WEBPACK FOOTER //
// src/components/Startups/Startups.js